import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Radio } from "lucide-react";

export default function LivePrice({ ticker, className = "" }) {
  const [q, setQ] = useState(null);

  useEffect(() => {
    let alive = true;
    const fetchQ = async () => {
      try {
        const res = await api.get(`/quote/${ticker}`);
        if (alive && res.data?.price != null) setQ(res.data);
      } catch (e) {}
    };
    fetchQ();
    const t = setInterval(fetchQ, 60000);
    return () => { alive = false; clearInterval(t); };
  }, [ticker]);

  const up = (q?.change_pct ?? 0) >= 0;

  return (
    <div className={`flex items-center justify-between bg-[var(--surface-base)] rounded-lg px-3 py-2 border border-[var(--border-subtle)] ${className}`} data-testid={`live-price-${ticker}`}>
      <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-bull">
        <Radio size={11} className="animate-pulse" /> Live
      </span>
      {q ? (
        <div className="flex items-center gap-2">
          <span className="font-mono-data font-extrabold text-base">Rp {Number(q.price).toLocaleString("id-ID")}</span>
          <span className={`font-mono-data text-xs font-semibold ${up ? "text-bull" : "text-bear"}`}>{up ? "▲ +" : "▼ "}{q.change_pct}%</span>
        </div>
      ) : (
        <span className="font-mono-data text-xs text-[var(--text-muted)]">memuat…</span>
      )}
    </div>
  );
}
